import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'

Vue.use(VueRouter)

export const constantRoutes = [
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'Home',
        component: () => import('@/views/home/index.vue'),
        meta: {
          title: '首页',
          isMenu: '1',
          icon: 'menu_home_icon',
          activeIcon: 'menu_home_icon1'
        }
      },
      {
        path: '/account',
        name: 'Account',
        component: () => import('@/views/system/account.vue'),
        meta: {
          title: '账号设置',
          isMenu: '1'
        }
      },
      {
        path: '/announcementDetail',
        name: 'AnnouncementDetail',
        component: () => import('@/views/system/announcement/detail.vue'),
        meta: {
          title: '公告详情',
          isMenu: '0'
        }
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: {
      title: '登录',
      isMenu: '0'
    },
    type: 'router',
    children: []
  }
]

const createRouter = () =>
  new VueRouter({
    routes: constantRoutes,
    scrollBehavior: () => ({
      y: 0
    }),
    mode: 'history'
  })

const router = createRouter()

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
